import React from 'react';

interface SVGProps {
  className?: string;
  width?: number | string;
  height?: number | string;
  fromColor?: string;
  toColor?: string;
  idPrefix?: string;
}

export const Ellipse13: React.FC<SVGProps> = ({ 
  className = "", 
  width = 418, 
  height = 316,
  fromColor = "#6E4AF6",
  toColor = "#9B2D9D",
  idPrefix = "ellipse13",
}) => (
  <svg 
    preserveAspectRatio="none"
    width="100%"
    height="100%"
    overflow="visible"
    style={{display: 'block'}}
    viewBox="0 0 1666 1565"
    fill="none"
    className={className}
  >
    <g id={`${idPrefix}-shape`} opacity="0.7" filter={`url(#${idPrefix}-filter)`}>
      <path d="M1042 797.818C1042 958.599 925.078 936.492 832.038 936.492C738.998 936.492 624 973.321 624 812.54C624 651.758 738.998 624 832.038 624C925.078 624 1042 637.036 1042 797.818Z" fill={`url(#${idPrefix}-gradient)`}/>
    </g>
    <defs>
      <filter id={`${idPrefix}-filter`} x="0" y="0" width="1666" height="1564.13" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="312" result="effect1_foregroundBlur"/>
      </filter>
      <linearGradient id={`${idPrefix}-gradient`} x1="1042" y1="783.139" x2="624" y2="783.139" gradientUnits="userSpaceOnUse">
        <stop stopColor={fromColor}/>
        <stop offset="1" stopColor={toColor}/>
      </linearGradient>
    </defs>
  </svg>
);
